import {VoteUrgency} from "@/types/integrations";

export type Importance = "nice_to_have" | "important" | "critical";

export const IMPORTANCE_OPTIONS: {
   value: Importance;
   labelKey: string;
   descriptionKey: string;
}[] = [
   {
      value: "nice_to_have",
      labelKey: "marketplaceNiceToHaveLabel",
      descriptionKey: "marketplaceNiceToHaveDescription",
   },
   {
      value: "important",
      labelKey: "marketplaceImportantLabel",
      descriptionKey: "marketplaceImportantDescription",
   },
   {
      value: "critical",
      labelKey: "marketplaceCriticalLabel",
      descriptionKey: "marketplaceCriticalDescription",
   },
];

export const IMPORTANCE_TO_URGENCY: Record<Importance, VoteUrgency> = {
   nice_to_have: VoteUrgency.Low,
   important: VoteUrgency.Medium,
   critical: VoteUrgency.High,
};
